import {Helmet} from '@dr.pogodin/react-helmet';
import {openDeleteDialog} from 'platform/components';
import {match} from 'ts-pattern';

import {always} from 'ramda';
import {isArray} from 'ramda-adjunct';

import {useDeleteWarrantyTypeMutation} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {DmsDataGrid, handleApiError} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function WarrantyTypes() {
  const navigate = useNavigate();

  const [deleteWarrantyType] = useDeleteWarrantyTypeMutation();

  const actionCallback: ActionCallback = ({actionKey, rowId, refreshData}) => {
    const id = isArray(rowId) ? rowId[0] : rowId;

    match(actionKey)
      .with('edit', 'redirectDetail', () =>
        navigate(composePath(settingsRoutes.warrantyTypesDetail, {params: {id}}))
      )
      .with('delete', () =>
        openDeleteDialog({
          onConfirm: () =>
            deleteWarrantyType({warrantyTypeId: id})
              .unwrap()
              .then(() => refreshData())
              .catch(handleApiError),
        })
      )
      .otherwise(always(undefined));
  };

  return (
    <>
      <Helmet title={i18n.t('page.vehicleSettings.labels.warrantyTypes')} />
      <SettingsTemplate
        header={{
          title: i18n.t('page.vehicleSettings.labels.warrantyTypes'),
          actions: [
            {
              type: 'button',
              title: i18n.t('entity.warrantyType.actions.new'),
              onClick: () => navigate(settingsRoutes.warrantyTypesCreate),
            },
          ],
        }}
        description={i18n.t('page.vehicleSettings.labels.warrantyTypesDescription')}
        data-testid={testIds.settings.warrantyTypes('template')}
      >
        <DmsDataGrid
          gridCode="warranty-type"
          actionCallback={actionCallback}
          data-testid={testIds.settings.warrantyTypes('datagrid')}
        />
      </SettingsTemplate>
    </>
  );
}
